<script lang="ts">
	import { Icon } from '@enzianweb/shared';	

	interface Props {
		iconName: string;
		name: string;
		children?: import('svelte').Snippet;
	}

	let { iconName, name, children }: Props = $props();

	let showContent: boolean = $state(false);
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	class="relative mx-4 py-2 border-b h-full border-transparent flex items-center gap-2 dark:fill-white"
	onmouseenter={() => {
		showContent = true;
	}}
	onmouseleave={() => {
		showContent = false;
	}}
>
	<Icon name={iconName}></Icon>
	<p class="text-lg truncate nav-text">
		{name}
	</p>

	{#if showContent}
		<div class="absolute top-0 left-0 bg-white z-40 dark:bg-dark-300">
			{@render children?.()}
		</div>
	{/if}
</div>

<style>
	.nav-text {
		display: none;
	}

	@media (min-width: 1760px) {
		.nav-text {
			display: block;
		}
	}
</style>
